<template>
  <div class="password-rules-hint">
    <p class="instruction">
      <button
        type="button"
        class="rules-toggle"
        @click="showRules = !showRules"
      >
        {{ showRules ? 'Hide password rules' : 'Show password rules' }}
      </button>
    </p>
    <ul v-if="showRules" class="rules-list">
      <li>At least 6 characters</li>
      <li>At least one digit</li>
      <li>At least one uppercase letter</li>
      <li>At least one lowercase letter</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PasswordRulesHint',
  data() {
    return {
      showRules: false
    };
  }
};
</script>

<style scoped>
.password-rules-hint {
  text-align: left;
  margin-bottom: 0.5rem;
}
.instruction {
  font-size: 0.875rem;
  margin: 0 0 0.25rem 0;
}
.rules-toggle {
  background: none;
  border: none;
  padding: 0;
  font-size: inherit;
  text-decoration: underline;
  cursor: pointer;
  color: inherit;
}
.rules-toggle:hover {
  opacity: 0.8;
}
.rules-list {
  margin: 0.25rem 0 0 1rem;
  padding-left: 0.5rem;
  font-size: 0.875rem;
}
</style>
